import { Unstable_Popup as BasePopup } from '@mui/base/Unstable_Popup'
import { styled } from '@mui/system'
import tableDot from '../../assets/icons/tableDot.svg'
import './popup.scss'
import { useState, useEffect } from 'react'
import { ClickAwayListener } from '@mui/base/ClickAwayListener';

function PopupBox({ children, rowData, popupRef ,isOpen, setIsOpen}) {
const [anchor, setAnchor] =useState(null)
  const handleClick = (event) => {
    setAnchor(anchor ? null : event.currentTarget)
    setIsOpen(false)
  }

  useEffect(()=>{
    if(isOpen)
    setAnchor(null)

  },[isOpen])

  const open = Boolean(anchor)
  const id = open ? `simple-popup-${rowData.id}` : undefined
  return (
    <div>
      <div aria-describedby={id} type='icon' onClick={handleClick} className='tableDot'>
        <img src={tableDot} alt='' />
      </div>

      {open && (
        <ClickAwayListener onClickAway={() => {
          setAnchor(null)
        }}>
          <BasePopup id={id} open={open} anchor={anchor} className='popup-parent'>
            <PopupBody className='main-div' id='main-div' ref={popupRef}>
              <div>
                {children}
              </div>
            </PopupBody>
          </BasePopup>
        </ClickAwayListener>
      )}
    </div>
  )
}

const grey = {
  50: '#F3F6F9',
  100: '#E5EAF2',
  200: '#DAE2ED',
  300: '#C7D0DD',
  400: '#B0B8C4',
  500: '#9DA8B7',
  600: '#6B7A90',
  700: '#434D5B',
  800: '#303740',
  900: '#1C2025',
}

const PopupBody = styled('div')(
  ({ theme }) => `
    width: max-content;
    padding: 12px 16px;
    margin-top: -30px;
    margin-right: -25px;
    border-radius: 8px;
    border: 1px solid ${theme.palette.mode === 'dark' ? grey[700] : grey[200]};
    background-color: ${theme.palette.mode === 'dark' ? grey[900] : '#fff'};
    box-shadow: ${theme.palette.mode === 'dark' ? `0px 4px 8px rgb(0 0 0 / 0.7)` : `0px 4px 8px rgb(0 0 0 / 0.1)`};
    font-family: 'IBM Plex Sans', sans-serif;
    font-weight: 500;
    font-size: 0.875rem;
    z-index: 1;
  `,
)

export default PopupBox
